<template>
  <div>
    <h5>{{ opportunity.term.description }}</h5>
    <a :href="opportunity.site.website" target="_blank">{{ opportunity.site.website }}</a>
    <show-more :text="opportunity.description" v-if="opportunity && opportunity.description"></show-more>

    <b-container class="mt-2">
      <b-row>
        <b-col sm="6">
          <dt>Opportunity</dt>
          <dd><router-link :to="{name: 'opportunity', params: { opportunityId: opportunity.opportunityId }}">{{(opportunity.translationalTeam ? (opportunity.translationalTeam.name + ' @ ' ) : '') + 
                    (opportunity.site ? opportunity.site.name : '') +
                    (opportunity.name ? ' (' + opportunity.name + ')': '' )}}</router-link></dd>
          <dt>Site</dt>
          <dd><router-link :to="{name: 'site', params: { siteId: opportunity.site.siteId }}">{{opportunity.site.name}}</router-link></dd>
          <dt>Minimum GPA</dt>
          <dd>
            <span v-if="!opportunity.recommendedGPA || opportunity.recommendedGPA === 0">No requirement</span>
            <span v-if="opportunity.recommendedGPA && opportunity.recommendedGPA != 0">{{ opportunity.recommendedGPA | number(2) }}</span>
          </dd>
          <dt>Recommended Credit Hours</dt>
          <dd>
            <span v-if="!opportunity.recommendedCreditHoursString || opportunity.recommendedCreditHoursString === ''">No requirement</span>
            <span v-if="opportunity.recommendedCreditHoursString != ''">{{ opportunity.recommendedCreditHoursString }}</span>
          </dd>
          <dt>Commitment Level</dt>
          <dd>
            <span v-if="!opportunity.commitmentLevel || opportunity.commitmentLevel === 0">No requirement</span>
            <span v-if="opportunity.commitmentLevel != 0">{{ opportunity.commitmentLevel }}</span>
          </dd>
        </b-col>
        <b-col sm="6">
          <dl class="dl-horizontal align-left">
            <div class="row" v-if="opportunity.opportunityType">
              <dl>
                <dt class="col-sm-12">Type / Category</dt>
                <dd class="col-sm-12">
                  <b-badge variant="primary">{{ opportunity.opportunityType.name }}
                  </b-badge>
                  <b-badge variant="primary">{{ opportunity.opportunityCategory.name }}
                  </b-badge>
                </dd>
              </dl>
            </div>
            
            <div class="row" v-if="opportunity.opportunityInternshipCourses.length"> 
              <dl>
                <dt class="col-sm-12">Courses</dt>
                <dd class="col-sm-12">
                  <span v-for="oic in opportunity.opportunityInternshipCourses" :key="oic.internshipCourseId">
                    <b-badge variant="primary">{{ oic.internshipCourse.displayName }}</b-badge>
                  </span>
                </dd>
              </dl>
            </div>
            
            <div class="row" v-if="opportunity.opportunityAreaOfInterests.length">
              <dl>
                <dt class="col-sm-12">Areas of Interest</dt>
                <dd class="col-sm-12">
                  <span v-for="oai in opportunity.opportunityAreaOfInterests" :key="oai.areaOfInterestId">
                    <b-badge variant="primary">{{ oai.areaOfInterest.name }}</b-badge>
                  </span>
                </dd>
              </dl>
            </div>

          </dl>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import ShowMore from "../../components/show-more";

export default {
  data() {
    return {};
  },

  props: {
    opportunity: {
      type: Object,
      required: true
    }
  },

  components: {
    "show-more": ShowMore
  }
};
</script>

<style scoped>
h5 {
  font-size: 0.9em;
}

.badge-primary {
  background-color: #428bca;
  margin: 3px;
  padding: 5px;
}
</style>
